// extracted by mini-css-extract-plugin
export default {"grid":"BooksGrid_grid__BsCKL","title":"BooksGrid_title__MPQ61"};